import htmlComponent from 'htmlcomponent'

export default function(dom, opts) {
	let options = {
        buttonSel: '[data-more]',
        buttonTextSel: '[data-text]',
        iconSel: '.neighbouring-caret',
        iconRotateCls: 'neighbouring-caret--rotate',
        shadowCls: 'collapsible__content--shadow',
		...opts
	};

	const desktopWidth = 1024;
	const baseClass = 'collapsible';
    const body = document.documentElement;
    const showMoreButton = body.querySelector(options.buttonSel);
    const buttonText = body.querySelector(options.buttonTextSel);
    const arrowIcon = body.querySelector(options.iconSel);
	const content = dom.querySelector(`.${baseClass}__content`);

	const contentTransition = e => {
        content.removeEventListener('transitionend', contentTransition );
        content.style.maxHeight = '';
	};

	if (!dom.classList.contains(`${baseClass}--collapsed`) && window.innerWidth < desktopWidth) {
		dom.classList.add(`${baseClass}--collapsed`);
	}

    showMoreButton.addEventListener('click', () => {

        setTimeout(() => {
            if (buttonText.innerHTML === `${options.translation.buttonLess}`) {
                buttonText.innerHTML = `${options.translation.buttonMore}`;
                arrowIcon.classList.remove(options.iconRotateCls);
            } else {
                buttonText.innerHTML = `${options.translation.buttonLess}`;
                arrowIcon.classList.add(options.iconRotateCls);
            }
            if (content.classList.contains(options.shadowCls)) {
                content.classList.remove(options.shadowCls)
            } else {
                content.classList.add(options.shadowCls)
            }

        }, 200);

        body.querySelector('.product-details__expand-table').classList.toggle('product-details__expand-table--transformed');
    });

    showMoreButton && content && showMoreButton.addEventListener('click', e => {
		e.preventDefault();

		content.removeEventListener('transitionend', contentTransition);
		content.addEventListener('transitionend', contentTransition);

		content.style.maxHeight = `${content.scrollHeight}px`;

		setTimeout(() => {
			dom.classList.toggle(`${baseClass}--collapsed`);

		}, 25);

		return false;
	});
}
